import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import Image from 'next/image';
import { ResponsiveImage } from './ResponsiveImage';

type ParallaxImageProps = {
  src?: string;
  alt?: string;
  blurDataURL?: string;
  verticalStart: string;
  verticalEnd: string;
  children?: React.ReactNode
  className?: string;
  isImageResponsive?: boolean;
  responsiveImageSources?: any;
};

export default function ParallaxImage({
  src,
  alt = '',
  blurDataURL,
  verticalStart,
  verticalEnd,
  children,
  className,
  isImageResponsive,
  responsiveImageSources,
}: ParallaxImageProps) {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], [verticalStart, verticalEnd]);

  return (
    <div ref={ref} className="absolute top-0 left-0 w-full h-full z-0">
      <motion.div
        className="absolute top-0 left-0 w-full h-full will-change-transform"
        style={{ y }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {children ? children : (
          isImageResponsive ? (
            <ResponsiveImage
              alt={alt}
              fallbackSrc={src}
              fallbackBlurDataURL={blurDataURL}
              sources={responsiveImageSources}
              imageProps={{
                className: className,
                priority: true,
                placeholder: 'blur',
              }}
            />
          ) : (
            <Image
              src={src}
              alt={alt}
              fill
              style={{ objectFit: 'cover' }}
              placeholder="blur"
              blurDataURL={blurDataURL}
              priority
              className={className ? className : ''}
            />
          )
        )}
      </motion.div>
    </div>
  );

}
